import { memo } from 'react';

import { useTranslate } from '@/hooks/useTranslate';

export type ViewMoreProps = {
  onExpand?: (value: boolean) => void;
  /** toggle: 展开/收起；action: 纯动作（不切换文案，常用于跳转到二级页） */
  behavior?: 'toggle' | 'action';
  /** 展开态（toggle 模式下由父组件控制） */
  expanded?: boolean;
};

const ViewMore = memo(
  ({ onExpand, behavior = 'toggle', expanded = false }: ViewMoreProps) => {
    const { t } = useTranslate();
    const isToggle = behavior === 'toggle';

    return (
      <div>
        <button
          type="button"
          className="flex items-center gap-[4px] px-[16px] py-[6px] rounded-[20px] border border-solid border-[#E5E5E5] bg-white text-[14px] text-[#333] cursor-pointer hover:bg-[#F5F5F5] transition-colors"
          onClick={() => onExpand?.(isToggle ? !expanded : true)}
        >
          <span>{isToggle && expanded ? t('home.viewLess') : t('home.viewMore')}</span>
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            className={`transition-transform ${isToggle && expanded ? 'rotate-180' : ''}`}
            aria-hidden
          >
            <path
              d="M2.5 4.5L6 8L9.5 4.5"
              stroke="#333"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    );
  },
);

ViewMore.displayName = 'ViewMore';

export default ViewMore;
